import React from "react";
import { Box, Card, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
  card: {
    minWidth: "380px",
    padding: "1em"
  },
  rating: {
    width: 140,
    height: 100,
    marginRight: "1em",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.secondary[100]
  },
  breakout: {
    alignSelf: "center"
  }
}));

const RatingQuestion = ({ question }) => {
  const classes = useStyles();
  return (
    <Card className={classes.card} maxWidth={100}>
      <Typography variant="subtitle1" sx={{ mb: 1.25 }}>
        {question.name}
      </Typography>
      <Box display="flex" justifyContent="space-between">
        <Box className={classes.rating}>
          <Typography variant="h3" sx={{ mb: 1, mt: 2.75 }}>
            {question.score && question.score.value}
          </Typography>
          <Typography variant="overline" sx={{ letterSpacing: "0.5px" }}>
            {question.score && question.score.label}
          </Typography>
        </Box>
        <Box
          flex={2}
          display="flex"
          flexDirection="column"
          justifyContent="space-around"
        >
          {question.breakout &&
            question.breakout.map((obj, i) => (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                key={`breakout-${i}`}
              >
                <Typography
                  variant="overline"
                  color="textSecondary"
                  sx={{ pr: 3, letterSpacing: 0 }}
                  noWrap
                  gutterBottom
                >
                  {obj.label}
                </Typography>
                <Typography variant="subtitle1" sx={{ mr: 2 }}>
                  {obj.value}
                </Typography>
              </Box>
            ))}
        </Box>
      </Box>
    </Card>
  );
};

export default RatingQuestion;

RatingQuestion.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    score: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    }),
    breakout: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      })
    )
  })
};
